import { isComponentOfType } from 'utils'
import { CalendarSingleArtistProps, CalendarMultiArtistProps, ComponentItem } from '~types'
import CalendarSingleArtist from './views/CalendarSingleArtist/CalendarSingleArtist'
import CalendarMultiArtist from './views/CalendarMultiArtist/CalendarMultiArtist'

const Calendar = (props: CalendarMultiArtistProps | CalendarSingleArtistProps | ComponentItem) => {
  if (!props) return null
  const variant = isComponentOfType(props as ComponentItem, 'Calendar') ? 'singleArtist' : 'multiArtist'
  return (
    <>
      {variant == 'singleArtist' ? (
        <CalendarSingleArtist {...(props as CalendarSingleArtistProps)} />
      ) : (
        <CalendarMultiArtist {...(props as CalendarMultiArtistProps)} />
      )}
    </>
  )
}

export default Calendar
